import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { ArrowRightCircle } from "react-bootstrap-icons";

import VolunteerGiftImg1 from '../../assets/img/volunteer-gift-img1.png';
import VolunteerGiftImg1Eng from '../../assets/img/volunteer-gift-img1-eng.png';

const Gift = ({language}) => {
    return (
        <section className="volunteer-gift">
            <Container>
                <Row className='align-items-center' >
                    <Col md={6}>
                        <div className="gift-bx">
                            <h2>{language === "Chinese" ? "成為 L’Étape 志工享有精美限定好禮！" : "BECOME AN L’ÉTAPE VOLUNTEER AND RECEIVE EXCLUSIVE GIFTS!" }</h2>
                            <h3>{language === "Chinese" ? "立即加入我們！" : "JOIN US NOW!"}</h3>
                            <ul>
                                <li>{language === "Chinese" ? "環法挑戰賽限定工作服" : "Exclusive L’Étape Sun Moon Lake Staff Uniform" }</li>
                                <li>{language === "Chinese" ? "獨一無二賽事體驗" : "A One-of-a-Kind Race Experience" }</li>
                                <li>{language === "Chinese" ? "其他精美禮品" : "More Great Gifts" }</li>
                                <li>{language === "Chinese" ? "志工證書" : "Volunteer Certificate" }</li>
                            </ul>
                            <button>{language === "Chinese" ? "立即報名" : "REGISTER NOW"} <ArrowRightCircle size={25} /></button>
                        </div>
                    </Col>
                    <Col md={6}>
                        {language === "Chinese" ? <img src={VolunteerGiftImg1} alt="志工好禮" /> : <img src={VolunteerGiftImg1Eng} alt="Volunteer gifts" />}
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default Gift